<template>
<div>

    <v-dialog v-model="dialog" persistent scrollable fullscreen>
        <v-card>
            <v-card-title class="text-h5 pl-6 font-weight-regular">Confirm Request
                <v-spacer/><v-btn icon @click="closeDialog"><v-icon>mdi-close</v-icon></v-btn>
            </v-card-title><v-divider/>
            <v-progress-linear :active="loading" :indeterminate="true"/>
            <v-card-text class="mt-4">
                <v-row>
                    <v-col cols="1">
                        <v-avatar tile class="avatar mr-6" size="84" style="border: 1px solid grey;border-radius: 10px !important;" @click.stop="openGallery(product.Attachments)" title="View Image">
                            <v-img v-if="product.Attachments.length" :src="imgWpx(product.Attachments[0].path, 400)" alt="image">
                                <template v-slot:placeholder>
                                    <v-icon size="50" color="blue-grey lighten-5">mdi-image</v-icon>
                                    <v-progress-circular width="3" size="24" indeterminate style="position: unset" color="deep-orange lighten-2"></v-progress-circular>
                                </template>
                            </v-img>
                        </v-avatar>
                    </v-col>
                    <v-col cols="6">
                        <div class="product-name">{{product.name}}</div>
                        <div>Ordered Date: {{orderedDate?moment(orderedDate).format('DD MMM YYYY'):'-'}}</div>
                        <div>Total Request: {{purchaseRequests.length}}</div>
                        <div>Best Rate: {{minRate | currencyFilter}}</div>
                    </v-col>
                    <v-col cols="12">
                      <v-card class="pa-4">
                        <v-card-title class="py-0"><h5>Pending Requests ({{pendingPurchaseRequests.length}})</h5></v-card-title>
                        <v-data-table :items="pendingPurchaseRequests" :headers="[...commonHeaders, ...pendingReqHeaders]">
                            <template v-slot:no-data>No Pending Purchase Request Available</template>
                            <template v-slot:item.name="{ item: {Vendor} }">
                                <v-avatar tile style="border: 1px solid grey; border-radius: 5px !important;" size="60" @click="openGallery([{path: Vendor.profileImage, type: 'IMAGE'}])" class="mr-6 my-3 avatar" title="View Image">
                                    <v-img v-if="Vendor.profileImage" :src="imgWpx(Vendor.profileImage, 200)" :alt="Vendor.name" @error="Vendor.profileImage = null">
                                        <template v-slot:placeholder>
                                            <v-icon size="50" color="blue-grey lighten-5">mdi-image</v-icon>
                                            <v-progress-circular width="3" size="24" indeterminate style="position: unset" color="deep-orange lighten-2"/>
                                        </template>
                                    </v-img>
                                    <v-icon v-else size="50" color="blue-grey lighten-4">mdi-account-circle</v-icon>
                                </v-avatar>
                                <span class="v-name ellipsis">
                                    <span :title="Vendor.name">{{ Vendor.name}}</span><br>
                                    <span :title="Vendor.vendorCode" class="f-12 grey--text text--darken-1">{{Vendor.vendorCode}}</span>
                                </span>
                            </template>
                            <template v-slot:item.totalPiece="{ item }">{{item.cartoons * item.qtyPerCartoon}}</template>
                            <template v-slot:item.rate="{ item }">{{item.rate | currencyFilter}}</template>
                            <template v-slot:item.created_at="{ item }">{{moment(item.created_at).format('DD MMM YYYY hh:mm A')}}</template>
                            <template v-slot:item.deliveryDate="{ item }">{{moment(item.deliveryDate).format('DD MMM YYYY')}}</template>
                            <template v-slot:item.action="{ item }">
                               <!-- <v-btn icon @click="onConfirmRequest(item)" title="Confirm Request"><v-icon>mdi-check-circle-outline</v-icon></v-btn> -->
                                <v-menu nudge-bottom="25">
                                    <template v-slot:activator="{ on:menu }">
                                        <v-btn small icon v-on="{...menu}"><v-icon>mdi-dots-vertical</v-icon></v-btn>
                                    </template>
                                    <v-list dense>
                                        <v-list-item @click="onConfirmRequest(item)"><v-list-item-title>Confirm Request</v-list-item-title></v-list-item>
                                        <v-list-item @click="onEditRequest(item)"><v-list-item-title>Edit Request</v-list-item-title></v-list-item>
                                        <v-list-item @click="onDeleteRequest(item)"><v-list-item-title>Delete Request</v-list-item-title></v-list-item>
                                    </v-list>
                                </v-menu>
                            </template>
                        </v-data-table>
                      </v-card>
                    </v-col>
                    <v-col cols="12">
                      <v-card class="pa-4">
                        <v-card-title class="py-0"><h5>Confirmed Requests ({{confirmedPurchaseRequests.length}})</h5></v-card-title>
                        <v-data-table :items="confirmedPurchaseRequests" :headers="[...commonHeaders, ...confirmedReqHeaders]">
                            <template v-slot:no-data>No Confirmed Purchase Request Available</template>
                            <template v-slot:item.name="{ item: {Vendor} }">
                                <v-avatar tile style="border: 1px solid grey; border-radius: 5px !important;" size="60" @click="openGallery([{path: Vendor.profileImage, type: 'IMAGE'}])" class="mr-6 my-3 avatar" title="View Image">
                                    <v-img v-if="Vendor.profileImage" :src="imgWpx(Vendor.profileImage, 200)" :alt="Vendor.name" @error="Vendor.profileImage = null">
                                        <template v-slot:placeholder>
                                            <v-icon size="50" color="blue-grey lighten-5">mdi-image</v-icon>
                                            <v-progress-circular width="3" size="24" indeterminate style="position: unset" color="deep-orange lighten-2"/>
                                        </template>
                                    </v-img>
                                    <v-icon v-else size="50" color="blue-grey lighten-4">mdi-account-circle</v-icon>
                                </v-avatar>
                                <span class="v-name ellipsis">
                                    <span :title="Vendor.name">{{ Vendor.name}}</span><br>
                                    <span :title="Vendor.vendorCode" class="f-12 grey--text text--darken-1">{{Vendor.vendorCode}}</span>
                                </span>
                            </template>
                            <template v-slot:item.totalPiece="{ item }">{{item.cartoons * item.qtyPerCartoon}}</template>
                            <template v-slot:item.rate="{ item }">{{item.rate | currencyFilter}}</template>
                            <template v-slot:item.created_at="{ item }">{{moment(item.created_at).format('DD MMM YYYY hh:mm A')}}</template>
                            <template v-slot:item.confirmedDate="{ item }">{{moment(item.confirmedDate).format('DD MMM YYYY hh:mm A')}}</template>
                            <template v-slot:item.deliveryDate="{ item }">{{moment(item.deliveryDate).format('DD MMM YYYY')}}</template>
                        </v-data-table>
                      </v-card>
                    </v-col>

                </v-row>
            </v-card-text>
        </v-card>
    </v-dialog>

    <PurchaseRequestForm :dialog.sync="purchaseRequestFormDialog" :id.sync="purchaseRequestId"/>
    <Snackbar :toaster="toaster"/>
    <ConfirmationDialog :confirmationMessage="confirm.message" @confirm="confirm.method" @close="confirm.closeMethod"
                        v-if="confirm.enable"/>
    <gallery id="gallery-reqs-per-product" :images="galleryImages" :index="galleryIndex" @close="galleryIndex=null"/>
</div>
</template>

<script>
import Constants from "../../../Constants/Constants";
import moment from 'moment';
import Snackbar from "../../../components/Common/Snackbar";
import gallery from '../../../mixins/gallery';
import updateRecord from '../../../mixins/updateRecord';
import {SUBSCRIBE_PURCHASE_REQUEST_BY_PRODUCT_ID_AND_ORDERED_DATE} from "../../../graphql/subscriptions/PurchaseRequest";
import {GET_PRODUCT_BY_ID_FOR_CART} from "../../../graphql/queries/Products";
import ConfirmationDialog from "../../../components/Common/ConfirmationDialog";
import {deleteRecordById} from "../../../graphql/mutations/Common";
import PurchaseRequestForm from "./PurchaseRequestForm";
let user = JSON.parse(localStorage.user);
export default {
    name: "RequestsPerProduct",
    components: {PurchaseRequestForm, ConfirmationDialog, Snackbar},
    props: ['dialog', 'productId', 'orderedDate'],
    mixins: [gallery, updateRecord],
    apollo: {
        $subscribe: {
            purchaseRequests: {
                query: SUBSCRIBE_PURCHASE_REQUEST_BY_PRODUCT_ID_AND_ORDERED_DATE,
                skip() {return !this.productId || !this.orderedDate},
                variables() {return {productId: this.productId, orderedDate: this.orderedDate}},
                result ({data}) { this.purchaseRequests = data.purchaseRequests; this.loading=false }
            },
        },
        product: {
            query: GET_PRODUCT_BY_ID_FOR_CART,
            fetchPolicy: 'network-only',
            skip () {return !this.productId},
            variables(){ return{ id: this.productId } },
            result ({data}) { this.product = data.product[0] },
        },
    },
    data() {
        return {
            moment, Constants,
            toaster: {enable: false},
            confirm: {enable: false},
            loading: true,
            product: {Attachments:[]},
            purchaseRequests: [],
            commonHeaders: [
                {text: 'VENDOR NAME', value: 'name', width:240}, {text: 'CARTOONS', value: 'cartoons'},
                {text: 'PIECE/CARTOON', value: 'qtyPerCartoon'},{text: 'TOTAL PIECE', value: 'totalPiece'},
                {text: 'RATE/PIECE', value: 'rate'},{text: 'PRODUCT TYPE', value: 'productType'},
                {text: 'TRANSPORTATION', value: 'transportation'}, {text: 'REQUESTED DATE', value: 'created_at', width:100},
                {text: 'EXPECTED DELIVERY DATE', value: 'deliveryDate'}
            ],
            pendingReqHeaders: [{text: 'ACTION', value: 'action'}],
            confirmedReqHeaders: [{text: 'CONFIRMED DATE', value: 'confirmedDate', width:100}],
            purchaseRequestId: null,
            purchaseRequestFormDialog: false,
            menu: false,
        }
    },
    computed:{
      pendingPurchaseRequests(){
          return this.purchaseRequests.filter(r => r.statusId === Constants.PRQStatuses.Pending);
      },
      confirmedPurchaseRequests(){
          return this.purchaseRequests.filter(r => [Constants.PRQStatuses.Confirmed, Constants.PRQStatuses.Received].includes(r.statusId));
      },
      minRate(){
          return Math.min(...this.purchaseRequests.map(r => r.rate));
      }
    },
    methods:{
        onEditRequest(row){
            this.purchaseRequestId = row.id;
            this.purchaseRequestFormDialog = true;
        },
        onConfirmRequest(row){
            this.confirm = {enable:true, message:'Are you sure want to confirm Purchase Request?',
                row, method:this.confirmRequest, closeMethod:this.closeConfirmPopup};
        },
        async confirmRequest(){
            let obj = {statusId:Constants.PRQStatuses.Confirmed, confirmedDate:moment().format(), updatedBy:user.id};
            await this.updateRecord(this.confirm.row.id, obj, 'PurchaseRequest');
            this.toaster = {color:'green', enable:true, message: `Purchase Request confirmed Successfully`};
            this.closeConfirmPopup();
        },
        onDeleteRequest(row){
            this.confirm = {enable:true, message:'Are you sure want to delete Purchase Request?',
                row, method:this.deleteRequest, closeMethod:this.closeConfirmPopup};
        },
        async deleteRequest(){
            await deleteRecordById(this, this.confirm.row.id, 'PurchaseRequest');
            this.toaster = {color:'green', enable:true, message: `Purchase Request deleted Successfully`};
            this.closeConfirmPopup();
        },
        closeConfirmPopup(){
            this.confirm = {enable: false};
        },
        closeDialog(){
            this.product = {Attachments:[]};
            this.purchaseRequests = [];
            this.$emit('update:dialog', false);
            this.$emit('update:productId', null);
            this.$emit('update:orderedDate', null);
        }
    }
}
</script>

<style scoped>
.avatar{
    cursor: pointer;
}
.product-name{
    font-size: 16px;
    font-weight: 600;
}
.bordered{
    border: 1px solid #e0e0e0;
    padding: 10px;
}
.table-title{
    font-size: 16px;
    font-weight: 600;
    padding: 0 0 8px 0;
}
.ellipsis{
    white-space: nowrap;
    overflow: hidden;
    text-overflow: ellipsis;
    cursor: default;
}
.v-name{
    display: inline-block;
    vertical-align: middle;
    width: 120px;
    max-width: 120px;
}
</style>